import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
// Store
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Logout } from '@cv-invision/core';
import { SetPDFAttachments } from './action/pdf-attachment.actions';
// Service
import { QualityDocumentService } from '../../service/document-quality.service';
// Model
import { OrderCI_PDFATTACHMENT_STATE_PATH, PdfAttachmentsDataModel, PdfAttachmentsStateModel } from './model/pdf-attachments-state.model';
import { DOCUMENT_ATTACHMENT_CATEGORIES } from '../../model/quality.constant';

@State<PdfAttachmentsStateModel>({
	name: OrderCI_PDFATTACHMENT_STATE_PATH,
	defaults: new PdfAttachmentsStateModel()
})
@Injectable()
export class PDFAttachmentsState {
	constructor(private qualityDocumentService: QualityDocumentService) {
	}

	/**
	 * Get the pdf attachments available for this order
	 */
	@Selector()
	static getPDFAttachments(state: PdfAttachmentsStateModel): PdfAttachmentsDataModel {
		return state.attachments;
	}

	/**
	 * Set the pdf attachments calling service.
	 * @param ctx: PdfAttachmentsStateModel
	 * @param orderId: any
	 */
	@Action(SetPDFAttachments)
	setPDFAttachments(ctx: StateContext<PdfAttachmentsStateModel>, { orderId }: SetPDFAttachments): any {
		this.qualityDocumentService.getOrderDocumentAttachments(orderId, DOCUMENT_ATTACHMENT_CATEGORIES.PDF)
			.pipe(
				tap(response => {
					ctx.patchState({
						attachments: response
					});
				})
			).subscribe();
	}
	/**
	 * Clear data on logout
	 * @param ctx: PdfAttachmentsStateModel
	 */
	@Action(Logout)
	logout(ctx: StateContext<PdfAttachmentsStateModel>): void {
		ctx.setState(new PdfAttachmentsStateModel());
	}
}
